import type { AnyAction } from 'redux';
import type { ThunkAction } from 'redux-thunk';
import * as reducerActions from './reducer';
import type {
  EntityDashboardConfiguration,
  EntityType,
  ListRequest,
  ReportFrequency,
  SummaryDataRequest,
  SummaryRecordPath,
  TimeBracketKey,
  TimePeriodRange
} from '../entity/performance/types';
import type { RootState } from '../../store';

export type DashboardThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  AnyAction
>;

export const init = (
  configurations: EntityDashboardConfiguration
): DashboardThunk => reducerActions.init(configurations) as unknown as DashboardThunk;

export const onValueChange = (path: string, value: unknown): AnyAction =>
  reducerActions.onValueChange(path, value);

export const getSummaryRecord = (
  id: string,
  type: EntityType,
  timeBracket: TimeBracketKey,
  dateFrom?: string | null,
  dateTo?: string | null,
  path?: SummaryRecordPath
): AnyAction =>
  reducerActions.getSummaryRecord(id, type, timeBracket, dateFrom ?? null, dateTo ?? null, path);

export const getSummaryDataRecord = (
  request: SummaryDataRequest
): AnyAction => reducerActions.getSummaryDataRecord(request);

export const getSummaryDataRecordRequest = (
  id: string,
  baseFilter: string,
  timePeriod: TimePeriodRange,
  timeBracket: TimeBracketKey,
  reportByDateAndMetricType: ReportFrequency
): SummaryDataRequest =>
  reducerActions.getSummaryDataRecordRequest(
    id,
    baseFilter,
    timePeriod,
    timeBracket,
    reportByDateAndMetricType
  ) as SummaryDataRequest;

export const getDonationListData = (
  listKey: string,
  id: string,
  request: ListRequest,
  invalidate?: boolean,
  cachedData?: unknown
): AnyAction =>
  reducerActions.getDonationListData(listKey, id, request, invalidate, cachedData);

export const getFundraiserListData = (
  listKey: string,
  id: string,
  request: ListRequest,
  invalidate?: boolean,
  cachedData?: unknown
): AnyAction =>
  reducerActions.getFundraiserListData(listKey, id, request, invalidate, cachedData);
